import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPin2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="pin-2"><path d="M15.75 2C16.1642 2 16.5 2.33579 16.5 2.75V8.63477C18.6114 10.0737 20 12.4994 20 15.25C20 15.6642 19.6642 16 19.25 16H12.75V20.3975C12.75 20.4651 12.7366 20.5325 12.71 20.5947L12.2295 21.7139C12.1429 21.9157 11.8571 21.9157 11.7705 21.7139L11.29 20.5947C11.2634 20.5325 11.25 20.4651 11.25 20.3975V16H4.75C4.33579 16 4 15.6642 4 15.25C4 12.4994 5.38861 10.0737 7.5 8.63477V2.75C7.5 2.33579 7.83579 2 8.25 2H15.75Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPin2;
